import React, { useEffect, useState } from 'react'

interface CongratulationsToastProps {
  message: string
  isVisible: boolean
  onComplete?: () => void
}

const CongratulationsToast: React.FC<CongratulationsToastProps> = ({
  message,
  isVisible,
  onComplete
}) => {
  const [shouldRender, setShouldRender] = useState(false)

  useEffect(() => {
    if (isVisible) {
      setShouldRender(true)
      
      // Auto-hide after 3 seconds
      const timer = setTimeout(() => {
        setShouldRender(false)
        if (onComplete) {
          setTimeout(onComplete, 300) // Wait for fade out animation
        }
      }, 3000)

      return () => clearTimeout(timer)
    } else {
      setShouldRender(false)
    }
  }, [isVisible, onComplete])

  if (!isVisible && !shouldRender) return null

  return (
    <div 
      className={`congratulations-toast ${shouldRender ? 'visible' : 'hidden'}`}
      style={{
        position: 'fixed',
        top: '20%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        background: 'linear-gradient(135deg, #528d4e, #45a049)',
        color: 'white',
        padding: '20px 30px',
        borderRadius: '15px',
        fontSize: '18px',
        fontWeight: 'bold',
        fontFamily: 'Arial, Helvetica, sans-serif',
        textAlign: 'center',
        zIndex: 1001,
        boxShadow: '0 8px 25px rgba(0, 0, 0, 0.3)',
        border: '3px solid #ffffff',
        minWidth: '300px',
        maxWidth: '90vw',
        opacity: shouldRender ? 1 : 0,
        transition: 'all 0.3s ease-in-out',
        animation: shouldRender ? 'congratsSlideIn 0.5s ease-out' : 'none'
      }}
    >
      {message}
    </div>
  )
}

export default CongratulationsToast